export default __webpack_public_path__ + "static/media/328.9017f782.jpg";